import React from 'react';
import { DeviceFull } from '../../../hooks/useGetCurrentUserDevices.js';
import { labelForBatteryMode } from '../../../services/device-config-utils';
import { DeviceConfigSyncStateIndicator } from '../../bits/DeviceConfigSyncStateIndicator';
import TileActionRowLink from '../../bits/TileActionRowLink.jsx';
import TileV2 from '../../bits/TileV2.tsx';

interface DeviceBatteryModePanelProps {
  device: DeviceFull;
  disabled?: boolean;
};

const syncIconStyle: React.CSSProperties = {
  position: 'absolute',
  right: '-32px',
};

/**
 * Component renders the device battery mode panel.
 */
export const DeviceBatteryModePanel: React.FC<DeviceBatteryModePanelProps> = ({ device, disabled = false }) => {
  return (
    <TileV2 disabled={disabled}>
      <TileActionRowLink
        label={"Battery Mode"}
        description={
          <span style={{ position: 'relative' }}>
            {labelForBatteryMode(device.latestDeviceConfig?.data.batteryMode)} 
            <DeviceConfigSyncStateIndicator syncState={device.latestDeviceConfig?.syncState} style={syncIconStyle}/>
          </span>
        }
        to={{
          pathname: `/m/devices/${device.id}/edit-battery-mode`,
          state: { origin: 'device_overview' },
        }}
      />
    </TileV2>
  );
};
